import { isTouch } from '../utils/helpers';
import { disableScrollLock, enableScrollLock } from '../utils/scrollLock';

let modal;

export function setupProductModal() {
    if (document.querySelector('.product-modal') && document.querySelector('.product-order-button')) {
        modal = document.querySelector('.product-modal');

        const buttons = document.querySelectorAll('.product-order-button');
        const back = modal.querySelectorAll('.product-modal__back-link, #product-orderflow-inquire-button');

        Array.from(buttons).forEach(button => {
            button.addEventListener('click', e => {
                e.preventDefault();
                open();
                enableScrollLock();
            });
        });

        Array.from(back).forEach(item => {
            item.addEventListener('click', e => {
                e.preventDefault();
                disableScrollLock();
                close();
            });
        });

        window.onhashchange = function(event) {
            if(event.newURL.indexOf('#') < 0) {
                modal.classList.remove('js-slide-in');
                disableScrollLock();
            }
        }
    }

    if (isTouch && document.querySelector('.product-modal') && !document.querySelector('.product-modal').classList.contains('not-logged-in')) {
        modal = document.querySelector('.product-modal');

        if (document.querySelector('.stock-card')) {
            //setupStockToggle();
        }
    }

    if(modal) {
        const closeUpsell = modal.querySelector('.close-upsell');
        const modalPopup = modal.querySelector('.modal__popup');
        if(closeUpsell) {
            closeUpsell.addEventListener('click', e => {
                modalPopup.classList.add('modal__popup--hidden');
            });
        }
    }

    if(document.querySelector('.bundle-toggle')) {
        Array.from(document.querySelectorAll('.bundle-toggle')).forEach(toggle => {
            toggle.addEventListener('click', event => {
                toggle.closest('.stock-card').classList.toggle('expanded')
            })
        });
    }
}

function open() {
    history.pushState({}, '', window.location + '#');
    modal.classList.add('js-slide-in');
}

function close() {
    history.back();
    modal.classList.remove('js-slide-in');
    disableScrollLock();
}
